import { configQuery, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import { getVariant } from '../../util/variants.js';

/**
 * Conditionally renders a slot with the active running experiment
 * variant.
 */
var ExperimentVwoComponent = /** @class */ (function (_super) {
    __extends(ExperimentVwoComponent, _super);
    function ExperimentVwoComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.variant = '';
        return _this;
    }
    ExperimentVwoComponent.prototype.created = function () {
        var _this = this;
        configQuery('vwoAbTests', function (vwoAbTestsConfig) { return __awaiter(_this, void 0, void 0, function () {
            var variant;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vwoAbTestsConfig) return [3 /*break*/, 2];
                        return [4 /*yield*/, getVariant(vwoAbTestsConfig)];
                    case 1:
                        variant = _a.sent();
                        this.variant = variant;
                        this.emitVariantChange();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Emits variant value for given experiment.
     */
    ExperimentVwoComponent.prototype.emitVariantChange = function () {
        return this.variant;
    };
    __decorate([
        Emit('variant-change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ExperimentVwoComponent.prototype, "emitVariantChange", null);
    ExperimentVwoComponent = __decorate([
        Component({
            name: 'experiment-vwo',
        })
    ], ExperimentVwoComponent);
    return ExperimentVwoComponent;
}(Mixins(MagicConfigMixin)));

export default ExperimentVwoComponent;
